mostHandler = {
    $panelMostItem: $('.panel-most-item'),
    $sectionMostRecomendation: $('section#most-recommendations'),
    $sectionMostPages: $('section#most-pages'),
    $triggerBackToMost: $('.trigger-back-to-most'),
    isDirectlyLoaded: false,

    changeUrl: function(prev_hash, title, next_hash) {
        window.history.pushState({'hash_url': prev_hash}, title, next_hash);
    },

    scrollToTop: function(){
        $("html, body").animate({ scrollTop: 0 }, 250);
        // setTimeout(
        //     function() {
        //         // window.scrollTo({top: 0, behavior: 'smooth'});
        //     }
        // , 0);
    },

    backToMost: function(e){
        //console.log(location.url);
        this.$sectionMostPages.children().addClass('hide');
        this.$sectionMostPages.addClass('hide');
        this.$sectionMostRecomendation.removeClass('hide');
    },

    goToMost: function(item) {
        var hash = '#'+item;
        var idDetailPage = '#page-details-'+item;

        this.$sectionMostRecomendation.addClass('hide');
        this.scrollToTop();
        this.$sectionMostPages.children().addClass('hide');
        this.$sectionMostPages.find(idDetailPage).removeClass('hide');
        this.$sectionMostPages.removeClass('hide');
        this.changeUrl('#most', 'Open '+hash, hash);
    },

    equalizeHeights: function($elements, adjustWindowHeight=false, doSetHeight=true) {
        var tempHeight = 0;
        $elements
            .each(function() {
                var itemHeight = 0;
                if (adjustWindowHeight) {
                    var viewportHeight = $(window).height() - $('header').outerHeight() - $('.intro-container').outerHeight();
                    itemHeight = Math.max($(this).outerHeight(), viewportHeight);
                } else {
                    itemHeight = $(this).outerHeight();
                }
                tempHeight = Math.max(tempHeight, itemHeight);
            })
            .data('outer-height', tempHeight);
        if (doSetHeight) {
            $elements.css('height', tempHeight);
        }
    },

    clickableActionBox: function() {
        var self = this;
        var $actionBoxes = $('.action-box');
        var $clickableActionBox = $actionBoxes.find('.title-container');
        if ($clickableActionBox.length > 0) {
            $clickableActionBox.on("click", function() {
                var mostItem = $(this).closest('.title-container').data('most');
                // use sectionMostPages as indicator if currently on recommendation page
                if (self.$sectionMostPages.length > 0) {
                    self.goToMost(mostItem);
                } else {
                    // currently no on recommendation page
                    document.location = '/recommendations/#'+mostItem;
                }
            });
            if (Foundation.MediaQuery.atLeast('medium')) {
                $clickableActionBox
                    .on("mouseenter", function() {
                        $(this).addClass('hovered');
                    })
                    .on("mouseleave", function() {
                        $(this).removeClass('hovered');
                    });
            }
        }
    },

    init: function(e) {
        var self = this;

        if (this.$panelMostItem.length == 0) return;

		window.history.replaceState({'hash_url': '#most'}, '');

        if (Foundation.MediaQuery.atLeast('medium')) {
            // equalize heights between MOST item containers
            // why note use equalizer? we don't know if this init() is called 
            // before or after foundation equalizer fires
            // find the highest of MOST actions containers, and save it for hover animation
            this.equalizeHeights(this.$panelMostItem.find('.actions-title'));
            this.equalizeHeights(this.$panelMostItem.find('.actions-outer'));
            this.equalizeHeights($('.most-item-container .item-cell-most'), true);
            this.$panelMostItem.find('.actions-outer')
                .height(0);
            this.$panelMostItem.find('.actions-outer .actions-container')
                .addClass('normal');
            this.$panelMostItem.css('opacity', 1);

            var headerHeight = $('header').outerHeight();
            var introHeight = $('.intro-container').outerHeight();
            $('.most-item-container').css('min-height', 'calc(100vh - '+(headerHeight+introHeight)+'px)');
            
            $('.most-item-container .item-cell-most')
                .on('mouseenter', function() {
                    var $actionsOuter = $(this).find('.actions-outer');
                    $actionsOuter
                        .css('transition', 'height 250ms')
                        .height($actionsOuter.data('outer-height'));
                    $actionsOuter.find('.actions-container')
                        .addClass('hovered');
                    // $("html, body").animate({ scrollTop: $(document).height() }, 250);
                })
                .on('mouseleave', function() {
                    var $actionsOuter = $(this).find('.actions-outer');
                    $actionsOuter.height(0);
                    $actionsOuter.find('.actions-container')
                        .removeClass('hovered');
                });

        }
        if (Foundation.MediaQuery.only('small')) {
            var $mostIntroContainer = this.$sectionMostRecomendation.find('.intro-container .content-cell-container');
            $mostIntroContainer.find('p').addClass('text-deck'); // weird design choice...
            $clamp($mostIntroContainer.get(0), {
                clamp: 4,
            });
            var $mostIntroReadMore = $('.most-intro-read-more');
            var $mostIntroClose = $('.most-intro-close');
            var clampLines = 4;
            $mostIntroReadMore.on("click", function(e) {
                e.preventDefault();
                $clamp($mostIntroContainer.get(0), {
                    clamp: 1000000,
                }); 
                $mostIntroContainer.css('height','auto');
                $mostIntroReadMore.addClass('hide');
                $mostIntroClose.removeClass('hide');
            });
            $mostIntroClose.on("click", function(e) {
                e.preventDefault();
                $clamp($mostIntroContainer.get(0), {
                    clamp: clampLines,
                });    
                $mostIntroContainer.css('height',(clampLines * 1.5)+'rem'); // 1.5 is assumed line height
                $mostIntroReadMore.removeClass('hide');
                $mostIntroClose.addClass('hide');
            });
            $mostIntroClose.trigger("click");
        }
        this.$panelMostItem
            .on('click', function(){
                var item = $(this).data('item'); 
                self.goToMost(item);
            });
        
        $('.item-action a').on("click", function(e) {
            e.stopPropagation();
        });

        this.$triggerBackToMost.on('click', function(){
            if (self.isDirectlyLoaded) {
                self.isDirectlyLoaded = false;
                window.location.href = window.location.href.split('#')[0];
            } else {
                window.history.back();
                // self.scrollToTop();
            }
        });

        window.addEventListener("popstate", function(event){
            if (event.state) {
                switch (event.state.hash_url) {
                    case '#most':
                        self.backToMost();    
                        break;
                    default:
                        break;
                } 
            }
        });

        this.clickableActionBox();
        
    }

}